export default __webpack_public_path__ + "static/media/case2-1 (5).2cd2d923.png";